import { FlashlightOffIcon } from './FlashlightOffIcon';

/**
 * author: Austin Andrews
 * id 043DEA8B-1F5B-49CE-BC9F-AA3FC802A58A
 * name flashlight-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flashlight-off.svg
 * tags
 */
export const TorchOffIcon = FlashlightOffIcon;
export default TorchOffIcon